import styled from 'styled-components';

export const SongMetricsContainer = styled.div`
  margin-top: 40px;
  margin-bottom: 40px;
  display: flex;
  flex-direction: row;
  width: 100%;
`;

export const SongMetricItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const SongMetricValue = styled.span`
  font-size: 16px;
  line-height: 24px;
  color: #f2f2f2;
`;

export const SongMetricUnit = styled.span`
  font-family: 'MabryPro';
  font-size: 12px;
  line-height: 12px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #9c9c9c;
`;
